import {getId} from 'apis/model/base'
import classNames from 'classnames'
import {createValue} from 'components/form/utils'
import DebounceSelect from 'components/LookupField/DebounceSelect'
import {API_ROOT_URL} from 'envs/_current/config'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import React from 'react'
import {BsFolder} from 'react-icons/bs'
import AntdConfigWrapper from 'views/AppLocals/custom/AntdConfigWrapper'
import {NullAsDefault} from 'views/Shared'
import {getTokenKey} from "../../../helpers/localStorage";
import ImageLoader from "../../../components/ImageLoader";

const renderItem = (item) => {
    return (
        {
            value: getId(item),
            label: (
                <span className="flex flex-col leading-tight">
                  <div className="flex gap-2 items-center justify-start">
                    <ImageLoader src={item?.avatar} style={{ width: 25, height: 20 }} />
                    <div className="font-medium text-sm text-color-000">
                      {getTitle(item)}
                    </div>
                  </div>
                </span>
            ),
        }
    )
}

export const fetchMedals =
  ({ owner_id, owner_type }) =>
  async (type, keyword) => {
    const response = await fetch(
      API_ROOT_URL +
        `/medals/${owner_type}/${owner_id}/get-medals?keyword=${keyword}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getTokenKey()}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const body = await response.json()
    return Array.from(_.get(body, 'data') || []).map(renderItem)
  }

export const searchMedals =
  ({ owner_id, owner_type }) =>
  async (type, keyword) => {
    const response = await fetch(
      API_ROOT_URL +
        `/medals/${owner_type}/${owner_id}/get-medals?keyword=${keyword}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getTokenKey()}`,
          'Content-Type': 'application/json',
          // Add other headers as needed
        },
      }
    )
    const body = await response.json()
    let options = _.get(body, 'data', [])
    return options.map((e) => ({
      value: getId(e),
      label: (
        <div className="flex gap-2 items-center justify-start">
          <BsFolder />
          ??? 11111111
          <div className="font-medium text-sm text-color-000">
            {getTitle(e)}
          </div>
        </div>
      ),
    }))
  }

export const MedalSingleSelect = ({
    className,
    name,
    type,
    owner_id,
    owner_type,
    value: id,
    onChange = NullAsDefault,
    defaultValue = [],
    ...props
}) => {
  return (
    <AntdConfigWrapper>
      <DebounceSelect
        name={name}
        type={type}
        value={id}
        className={classNames('w-full', className)}
        notFoundContent={undefined}
        onChange={(value) => {
          onChange(createValue(name, value))
        }}
        excludedOptions={
          _.isArray(defaultValue)
            ? Array.from(defaultValue).map(renderItem)
            : undefined
        }
        fetchOptions={fetchMedals({
          owner_id,
          owner_type,
        })}
        {...props}
      />
    </AntdConfigWrapper>
  )
}

export const MedalSelect = ({
  className,
  name,
  type,
  owner_id,
  owner_type,
  value: ids,
  onChange = NullAsDefault,
  defaultValue = [],
  ...props
}) => {
  return (
    <AntdConfigWrapper>
      <DebounceSelect
        name={name}
        type={type}
        value={ids}
        mode="multiple"
        className={classNames('w-full', className)}
        notFoundContent={undefined}
        onChange={(value) => {
          onChange(createValue(name, value))
        }}
        excludedOptions={
          _.isArray(defaultValue)
            ? Array.from(defaultValue).map(renderItem)
            : undefined
        }
        fetchOptions={fetchMedals({
          owner_id,
          owner_type,
        })}
        {...props}
      />
    </AntdConfigWrapper>
  )
}

export default MedalSelect
